var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetterMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 10,
    viewBox: "0 0 231 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 10,
    fill: "#2CDB3E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    width: 75,
    height: 10,
    fill: "#2CDB3E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    width: 75,
    height: 10,
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetterMeter);
export default __webpack_public_path__ + "static/media/BetterMeter.a0f40566719f63647d3735c6c3b5c56e.svg";
export { ForwardRef as ReactComponent };